<div>
  <div>Related products</div>

  <div *ngIf="allowOverrides" >
    <mat-icon
      *ngIf="allowOverrides"
      mat-icon-button
      matTooltip="{{'MENU.DISHES.NEW.ADD' | translate}}"
      class="size-scale-edit-button"
      (click)="onOpen(null)">add_box
    </mat-icon>
  </div>

  <div>
    <mat-chip-list class="tags-chip-list" aria-label="Tags selection">
      <mat-chip *ngFor="let rpi of relatedProductInfos"
                [removable]="true"
                (click)="onOpen(rpi)">
        {{ rpi.name ?? "no name" }}
        <button
          matChipRemove
          *ngIf="allowOverrides"
          (click)="onDelete(rpi)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>
  </div>

</div>
